import { useEffect, useState } from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  TextField,
} from "@mui/material";
import { LAB_LIMITS, reasonError } from "utils/externalLabRules";

const ExternalLabActionDialog = ({
  open,
  title,
  description,
  confirmLabel,
  confirmColor = "primary",
  input = "none",
  inputLabel,
  busy,
  onCancel,
  onConfirm,
}) => {
  const [text, setText] = useState("");
  const [touched, setTouched] = useState(false);

  useEffect(() => {
    if (open) {
      setText("");
      setTouched(false);
    }
  }, [open]);

  const error = input === "reason" ? reasonError(text) : "";

  const submit = () => {
    setTouched(true);
    if (error) return;
    onConfirm(text.trim());
  };

  return (
    <Dialog open={open} onClose={() => !busy && onCancel()} fullWidth maxWidth="xs">
      <DialogTitle sx={{ fontWeight: 700, fontSize: 17 }}>{title}</DialogTitle>
      <DialogContent dividers>
        {description && (
          <DialogContentText sx={{ fontSize: 14 }}>{description}</DialogContentText>
        )}
        {input !== "none" && (
          <TextField
            label={inputLabel || (input === "reason" ? "Reason" : "Note (optional)")}
            required={input === "reason"}
            fullWidth
            size="small"
            multiline
            minRows={3}
            sx={{ mt: 2 }}
            value={text}
            inputProps={{ maxLength: LAB_LIMITS.reasonMax, "data-testid": "action-dialog-text" }}
            error={touched && Boolean(error)}
            helperText={
              touched && error ? error : "Recorded in the lab's verification history."
            }
            onChange={(event) => setText(event.target.value)}
          />
        )}
      </DialogContent>
      <DialogActions sx={{ px: 3, py: 2 }}>
        <Button
          onClick={onCancel}
          disabled={busy}
          sx={{ textTransform: "none", color: "#6B7280", fontWeight: 600 }}
        >
          Cancel
        </Button>
        <Button
          variant="contained"
          color={confirmColor}
          onClick={submit}
          disabled={busy}
          sx={{ textTransform: "none", fontWeight: 700 }}
        >
          {busy ? "Working…" : confirmLabel}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ExternalLabActionDialog;
